'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function GoldFunnelModel(activityLog) {
	let funnelId = 'direct';
	const self = observable(this),
		logCategory = 'goldFunnel';
	self.setFunnelId = function (newFunnelId) {
		funnelId = newFunnelId;
	};
	self.step = function (segment, stepName) {
		activityLog.log(logCategory, segment + ':' + stepName, funnelId);
	};
};
